import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/switchBtn.png'
import _imports_1 from '../assets/1.png'
import _imports_2 from '../assets/2.png'
import _imports_3 from '../assets/3.png'
import _imports_4 from '../assets/4.png'
import _imports_5 from '../assets/5.png'


const _withScopeId = n => (_pushScopeId("data-v-f9c9838c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = { class: "homeTopContent" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "btn"
}, null, -1))
const _hoisted_7 = { class: "flowContent" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "userFlow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "已用流量", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "line" }, null, -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "userTotalFlow" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "剩余流量", -1))
const _hoisted_15 = { class: "schedule" }
const _hoisted_16 = { class: "scheduleLine" }
const _hoisted_17 = { class: "percentage" }
const _hoisted_18 = { class: "cardInfo" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "infoList",
  style: {"padding":"15px 0"}
}, "卡片信息", -1))
const _hoisted_20 = { class: "infoList" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "流量套餐")
], -1))
const _hoisted_22 = {
  key: 0,
  class: "right"
}
const _hoisted_23 = { class: "infoList" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "卡片状态")
], -1))
const _hoisted_25 = { class: "right" }
const _hoisted_26 = { class: "infoList" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "服务期止")
], -1))
const _hoisted_28 = { class: "infoList" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "剩余时长")
], -1))
const _hoisted_30 = { class: "right" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "实名状态")
], -1))
const _hoisted_32 = { class: "status" }
const _hoisted_33 = {
  key: 1,
  class: "infoList"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "实名状态")
], -1))
const _hoisted_35 = { class: "status" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoLeft" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "网络优选")
], -1))
const _hoisted_37 = { class: "status" }
const _hoisted_38 = { class: "cardInfo" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTitle" }, "当前卡未实名认证", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupContent" }, "根据工信部《入网用户真实身份信息登记规定》，您当前使用的流量卡或设备", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTimer" }, "实名认证开放时间: 每日07:30-22:00", -1))
const _hoisted_42 = {
  key: 0,
  class: "popupAlert"
}
const _hoisted_43 = { class: "popupBtn" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("智能优选网络"),
  /*#__PURE__*/_createElementVNode("span", { class: "hot" }, "推荐")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "describe" }, "三网信号情况，智能选择最优网络", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "中国电信", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "describe" }, "选择电信2G、3G、4G以及5GFDD-LTE", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "中国移动", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "describe" }, "选择移动2G、3G、4G以及5GTD-LTE2", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "中国联通", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "describe" }, "选择联通2G、3G、4G以及5G TD-LTE FDD-LTE", -1))
const _hoisted_52 = { class: "popupBtnStatus" }

import { 
    getWifiLoginAuth,
    getWifiCustomizationCardQueryCardMsg,
    getWifiCustomizationCardQueryCardRealNameStatus,
    getWifiCustomizationCardChooseBestNet
  } from '@/api'
  import { onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { showToast } from 'vant';
  import store from '@/store'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const status = ref(false)
  const realNamestatus = ref(false)
  const cardRealNameStatus = ref(false)
  let cardData = ref<any>()
  let bestNetId = ref<Number>()

  function goRealName () {
    router.push({ name: 'realName', params: {
      iccid: route.params.iccid
    }})
  }

  function toFixedNumber(userFlow: any, totalFlow: any) {
    return (userFlow / totalFlow * 100).toFixed(2)
  }

  function progressBar(userFlow: any, totalFlow: any) {
    return (100 - (userFlow / totalFlow * 100)).toFixed(2)
  }

  function goSelectCard() {
    router.push({ name: 'selectCard', params: {
      iccid: route.params.iccid
    }})
  }

  function getNamestatus() {
    // realNamestatus.value = false
    getWifiCustomizationCardQueryCardRealNameStatus({ iccid: route.params.iccid })
      .then((res: any) => {
        if (res.result) {
          _getWifiCustomizationCardQueryCardMsg()
          realNamestatus.value = false
        } else {
          showToast('您还未认证');
        }
      })
  }

  function updateBeatNet() {
    let params = {
      bestNetId: bestNetId.value,
      iccid: route.params.iccid
    }
    getWifiCustomizationCardChooseBestNet(params)
      .then((res: any) => {
        if (res.code === 200) {
          status.value = false
          _getWifiCustomizationCardQueryCardMsg()
        } else {
          showToast(res.result);
        }
      })
  }

  function goPayPackage() {
    router.push({ path: '/purchasePackage', query: {
      iccid: route.params.iccid,
      phone: cardData.value.phone,
      cardStatus: cardData.value.cardStatus
    }})
  }

  function getBestNetIdName(argument: any) {
    const listName = new Map([
      [0, '智能优选网络'],
      [1, '中国电信'],
      [2, '中国移动'],
      [3, '中国联通'],
    ])
    return listName.get(argument)
  }

  function getRealName(argument: any) {
    const listRealName = new Map([
      ['1', '未认证'],
      ['2', '已认证'],
      ['3', '认证失败'],
    ])
    return listRealName.get(argument)
  }

  function toRealName () {
    cardRealNameStatus.value = false
    realNamestatus.value = true
  }

  function updateStatus () {
    bestNetId.value = JSON.parse(JSON.stringify(cardData.value.bestNetId))
    status.value = true
  }

  function _getWifiCustomizationCardQueryCardMsg() {
    getWifiCustomizationCardQueryCardMsg({ iccid: route.params.iccid })
      .then((res: any) => {
        console.log(res)
        if (res.code === 200) {
          cardData.value = res.result
        }
      })
  }

  function goPay () {
    goPayPackage()
  }

  onMounted(() => {
    if (route.query.hasOwnProperty('userId')) {
      store.commit('setAppid', route.query.mpAppId)
      store.commit('setTenantId', route.query.cmeId)
      store.commit('setUserId', route.query.userId)
      _getWifiCustomizationCardQueryCardMsg()
    } else {
      getWifiLoginAuth(route.params.iccid).then((res: any) => {
        if (res.code === 200) {
          window.location.href = res.result
        } else {
          showToast({ message: res.message, forbidClick: true, });
        }
      })
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!

  return (_unref(cardData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, "ICCID：" + _toDisplayString(_unref(route).params.iccid? _unref(route).params.iccid: '- -'), 1),
          _createElementVNode("li", _hoisted_4, "卡号：" + _toDisplayString(_unref(cardData).phone? _unref(cardData).phone: '- -'), 1),
          _createElementVNode("li", _hoisted_5, "卡状态：" + _toDisplayString(_unref(cardData).cardStatus? _unref(cardData).cardStatus: '- -'), 1)
        ]),
        _createElementVNode("p", {
          class: "switchBtn",
          onClick: goSelectCard
        }, [
          _hoisted_6,
          _createTextVNode(" 切换")
        ]),
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(cardData).flowUsedText? _unref(cardData).flowUsedText: '- -'), 1),
            _hoisted_10
          ]),
          _hoisted_11,
          _createElementVNode("li", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(cardData).flowLeaveText? _unref(cardData).flowLeaveText: '- -'), 1),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "lineContent",
              style: _normalizeStyle({ transform: `translate(-${_unref(cardData).flowTotal === 0? 100: progressBar(_unref(cardData).flowUsed, _unref(cardData).flowTotal)}%, 0)` })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(cardData).flowTotal === 0? 0: toFixedNumber(_unref(cardData).flowUsed, _unref(cardData).flowTotal)) + "%", 1)
        ]),
        _createElementVNode("ul", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("li", _hoisted_20, [
            _hoisted_21,
            (_unref(cardData).agentPackageName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_unref(cardData).agentPackageName), 1))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "right",
                  onClick: goPay
                }, "暂未订购"))
          ]),
          _createElementVNode("li", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(cardData).cardStatus? _unref(cardData).cardStatus: '- -'), 1)
          ]),
          _createElementVNode("li", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("p", null, _toDisplayString(_unref(cardData).billEndDate? _unref(cardData).billEndDate: '- -'), 1)
          ]),
          _createElementVNode("li", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(cardData).surplusDays? _unref(cardData).surplusDays: '- -') + "天", 1)
          ]),
          (_unref(cardData).realNameStatus !== '2')
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "infoList",
                onClick: toRealName
              }, [
                _hoisted_31,
                _createElementVNode("p", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_unref(cardData).realNameStatus? getRealName(_unref(cardData).realNameStatus): '- -'), 1),
                  _createVNode(_component_van_icon, { name: "arrow" })
                ])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("p", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_unref(cardData).realNameStatus? getRealName(_unref(cardData).realNameStatus): '- -'), 1),
                  _createVNode(_component_van_icon, { name: "arrow" })
                ])
              ])),
          _createElementVNode("li", {
            class: "infoList",
            onClick: updateStatus
          }, [
            _hoisted_36,
            _createElementVNode("p", _hoisted_37, [
              _createTextVNode(_toDisplayString(_unref(cardData).bestNetId !== null? getBestNetIdName(_unref(cardData).bestNetId): '- -'), 1),
              _createVNode(_component_van_icon, { name: "arrow" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_van_button, {
            type: "primary",
            color: "#F9DA4E",
            class: "goPayBtn",
            onClick: goPay
          }, {
            default: _withCtx(() => [
              _createTextVNode("购买套餐")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_van_popup, {
          show: realNamestatus.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((realNamestatus).value = $event)),
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_39,
            _hoisted_40,
            _hoisted_41,
            (cardRealNameStatus.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_42, "如已实名，可能会存在同步延时，请稍后再查看，现可点击继续购买进入套餐充值页面"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              (cardRealNameStatus.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "btn",
                    style: {"border-right":"1px solid #F7F7F7"},
                    onClick: goPayPackage
                  }, "继续购买"))
                : _createCommentVNode("", true),
              (!cardRealNameStatus.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "btn",
                    style: {"border-right":"1px solid #F7F7F7"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (realNamestatus.value = false))
                  }, "取消"))
                : _createCommentVNode("", true),
              (!cardRealNameStatus.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: "btn",
                    style: {"border-right":"1px solid #F7F7F7"},
                    onClick: getNamestatus
                  }, "我已认证"))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: "btn rightBtn",
                onClick: goRealName
              }, "立即认证")
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: status.value,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((status).value = $event)),
          round: "",
          "close-on-popstate": true,
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_radio_group, {
              modelValue: _unref(bestNetId),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(bestNetId) ? (bestNetId).value = $event : bestNetId = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_radio, {
                  name: 0,
                  "label-position": "left",
                  class: "popupGroup"
                }, {
                  default: _withCtx(() => [
                    _hoisted_44,
                    _hoisted_45
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_radio, {
                  name: 1,
                  "label-position": "left",
                  class: "popupGroup"
                }, {
                  default: _withCtx(() => [
                    _hoisted_46,
                    _hoisted_47
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_radio, {
                  name: 2,
                  "label-position": "left",
                  class: "popupGroup"
                }, {
                  default: _withCtx(() => [
                    _hoisted_48,
                    _hoisted_49
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_radio, {
                  name: 3,
                  "label-position": "left",
                  class: "popupGroup"
                }, {
                  default: _withCtx(() => [
                    _hoisted_50,
                    _hoisted_51
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("p", {
                class: "btn left",
                onClick: updateBeatNet
              }, "确认"),
              _createElementVNode("p", {
                class: "btn right",
                style: {"border-right":"1px solid #F7F7F7"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (status.value = false))
              }, "关闭")
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

})